import React, { PureComponent } from 'react';
import TabbedComponents from '../components/TabbedComponents';
import DependenciesRow from '../components/DependenciesPage/DependenciesRow';
import DependenciesHeader from '../components/DependenciesPage/DependenciesHeader';
import { BASE_URL } from '../config';
require('!style!css!less!../css/table.less'); // eslint-disable-line

// define columns here. override dependency type with object.
const interestingDeps = [
  { package: 'react', source: 'peerDependencies' },
  { package: 'akutil-common', source: 'dependencies' },
  { package: '@atlaskit/util-shared-styles', source: 'dependencies' },
];

const firstColWidth = 10 - interestingDeps.length;

export default class DependenciesPage extends PureComponent {
  state = {
    components: [],
  };

  componentDidMount() {
    fetch(`${BASE_URL}/spa_data/dependencies_page.json`)
      .then(result => result.json())
      .then((json) => {
        this.setState({
          components: json,
        });
      });
  }

  render() {
    return (
      <div>
        <h2 style={{margin: '28px 10px 26px 10px'}}>Dependencies</h2>
        <TabbedComponents
          components={this.state.components}
          header={DependenciesHeader}
          row={DependenciesRow}
          extraProps={{ interestingDeps, firstColWidth }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DependenciesPage.jsx